<!--
  SINGLE FORM VIEW FOR © AREA 19, OCG WEB APP.

  DEVELOPED IN MONTREAL, QC, CANADA.
  MARCH 2025.
 -->

<script setup lang="tsx">
import { onMounted, ref } from 'vue';

import VersionNumber from '../components/VersionNumber.vue';

const props = defineProps({
  width: {
    type: String,
  },
});
const loaded = ref(false);

onMounted(() => {
  setTimeout(() => {
    loaded.value = true;
  }, 100);
});
</script>

<template>
  <div class="flex flex-column w-full h-screen">
    <div
      class="glass-panel py-10 px-6 w-[32rem] not-loaded self-center form"
      style="margin-top: 5%"
      :class="{
        'opacity-100': loaded,
        'opacity-0': !loaded,
      }"
      :style="{ width: props.width ? props.width : '' }"
    >
      <slot />
      <VersionNumber />
    </div>
  </div>
</template>

<style scoped>
.form {
  min-width: 200px;
  max-width: 60vw;
}
</style>
